import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=356556d2&scoped=true&"
import script from "./Playlists.vue?vue&type=script&lang=js&"
export * from "./Playlists.vue?vue&type=script&lang=js&"
import style0 from "./Playlists.vue?vue&type=style&index=0&id=356556d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356556d2",
  null
  
)

export default component.exports